/* YYorrZ — inline header search enhancer */
(function(){
  'use strict';

  function initInlineSearch(){
    var header=document.querySelector('[data-site-header]');
    if(!header) return;

    var searchModal=header.querySelector('[data-search-modal]');
    var searchTrigger=header.querySelector('[data-search-open]');
    var headerInner=header.querySelector('.header-top__inner');
    var headerActions=header.querySelector('.header-actions');

    if(!searchModal||!searchTrigger||!headerInner||!headerActions) return;
    if(searchModal.dataset.yyzInlineSearchReady==='true') return;
    searchModal.dataset.yyzInlineSearchReady='true';

    /* Move the existing search UI into the upper header row so it is never a separate popup. */
    headerInner.insertBefore(searchModal,headerActions);
    searchModal.removeAttribute('aria-modal');
    searchModal.removeAttribute('role');
    searchModal.setAttribute('aria-label','Search YYorrZ');

    var form=searchModal.querySelector('form');
    var input=form&&form.querySelector('input[type="search"]');
    var typeInput=form&&form.querySelector('input[name="type"]');

    if(typeInput) typeInput.value='product,page,article';
    if(input){
      input.setAttribute('placeholder','Search YYorrZ');
      input.setAttribute('aria-label','Search products, pages and articles');
      input.setAttribute('autocapitalize','off');
      input.setAttribute('spellcheck','false');
    }

    searchTrigger.setAttribute('aria-label','Search');
    searchTrigger.setAttribute('aria-controls','SearchModal');

    var closeButton=document.createElement('button');
    closeButton.type='button';
    closeButton.className='header-inline-search__close';
    closeButton.setAttribute('aria-label','Close search');
    closeButton.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    if(form) form.appendChild(closeButton);

    function closeInlineSearch(restoreFocus){
      searchModal.classList.remove('is-open');
      searchTrigger.setAttribute('aria-expanded','false');
      if(restoreFocus) searchTrigger.focus();
    }

    /* theme.js opens the existing search element; keep focus in this inline field. */
    searchTrigger.addEventListener('click',function(){
      window.setTimeout(function(){
        if(input) input.focus();
      },30);
    });

    closeButton.addEventListener('click',function(){
      closeInlineSearch(true);
    });

    if(form){
      form.addEventListener('submit',function(event){
        if(!input||!input.value.trim()){
          event.preventDefault();
          if(input) input.focus();
        }
      });
    }

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&searchModal.classList.contains('is-open')){
        closeInlineSearch(false);
      }
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initInlineSearch);
  }else{
    initInlineSearch();
  }
})();

/* YYorrZ — desktop full-screen slide-down navigation */
(function(){
  'use strict';

  function initDesktopOverlayNav(){
    var root=document.documentElement;
    var header=document.querySelector('[data-site-header]');
    if(!header) return;

    var nav=header.querySelector('.header-nav-bar');
    var headerInner=header.querySelector('.header-top__inner');
    if(!nav||!headerInner||nav.dataset.yyzDesktopOverlayReady==='true') return;
    nav.dataset.yyzDesktopOverlayReady='true';

    nav.id='DesktopNavOverlay';
    nav.setAttribute('aria-hidden','true');

    var menuButton=document.createElement('button');
    menuButton.type='button';
    menuButton.className='desktop-overlay-menu-toggle';
    menuButton.setAttribute('aria-label','Open menu');
    menuButton.setAttribute('aria-expanded','false');
    menuButton.setAttribute('aria-controls','DesktopNavOverlay');
    menuButton.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55" aria-hidden="true"><path d="M3 7h18M3 12h18M3 17h18"/></svg><span>Menu</span>';
    headerInner.appendChild(menuButton);

    var closeButton=document.createElement('button');
    closeButton.type='button';
    closeButton.className='desktop-overlay-close';
    closeButton.setAttribute('aria-label','Close menu');
    closeButton.innerHTML='<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" aria-hidden="true"><path d="M19 5 5 19M5 5l14 14"/></svg>';
    nav.insertBefore(closeButton,nav.firstChild);

    var lastFocus=null;

    function desktopMode(){
      return window.matchMedia('(min-width:1200px)').matches&&!root.classList.contains('yyz-tablet-device');
    }

    function closeInlineSearch(){
      var search=header.querySelector('[data-search-modal]');
      var trigger=header.querySelector('[data-search-open]');
      if(search) search.classList.remove('is-open');
      if(trigger) trigger.setAttribute('aria-expanded','false');
    }

    function setOpen(open,restoreFocus){
      if(open&&!desktopMode()) return;

      if(open){
        lastFocus=document.activeElement;
        closeInlineSearch();
      }

      nav.classList.toggle('is-desktop-overlay-open',open);
      document.body.classList.toggle('desktop-nav-open',open);
      nav.setAttribute('aria-hidden',open?'false':'true');
      menuButton.setAttribute('aria-expanded',open?'true':'false');

      if(open){
        window.setTimeout(function(){closeButton.focus()},40);
      }else if(restoreFocus!==false){
        menuButton.focus();
      }
    }

    menuButton.addEventListener('click',function(){
      setOpen(!nav.classList.contains('is-desktop-overlay-open'),true);
    });

    closeButton.addEventListener('click',function(){
      setOpen(false,true);
    });

    nav.addEventListener('click',function(event){
      var link=event.target.closest&&event.target.closest('a');
      if(link) setOpen(false,false);
    });

    var searchTrigger=header.querySelector('[data-search-open]');
    if(searchTrigger){
      searchTrigger.addEventListener('click',function(){
        if(nav.classList.contains('is-desktop-overlay-open')) setOpen(false,false);
      });
    }

    document.addEventListener('keydown',function(event){
      if(!nav.classList.contains('is-desktop-overlay-open')) return;

      if(event.key==='Escape'){
        event.preventDefault();
        setOpen(false,true);
        return;
      }

      if(event.key==='Tab'){
        var focusables=Array.prototype.slice.call(
          nav.querySelectorAll('a[href],button:not([disabled])')
        ).filter(function(el){
          var style=window.getComputedStyle(el);
          return style.visibility!=='hidden'&&style.display!=='none';
        });

        if(!focusables.length) return;
        var first=focusables[0];
        var last=focusables[focusables.length-1];

        if(event.shiftKey&&document.activeElement===first){
          event.preventDefault();
          last.focus();
        }else if(!event.shiftKey&&document.activeElement===last){
          event.preventDefault();
          first.focus();
        }
      }
    });

    function syncMode(){
      if(!desktopMode()&&nav.classList.contains('is-desktop-overlay-open')){
        setOpen(false,false);
      }
      if(!desktopMode()){
        nav.setAttribute('aria-hidden','true');
      }
    }

    window.addEventListener('resize',syncMode,{passive:true});
    window.addEventListener('orientationchange',syncMode,{passive:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initDesktopOverlayNav);
  }else{
    initDesktopOverlayNav();
  }
})();
